import React from 'react';
import { get2DKeyHandler } from 't-lib-ui/structure';
import { CategoryIcon, categoryColorMap } from './CategoryIcons';
import { formatCategory } from '../utils/formatting';
import './CategoryTile.css';

interface CategoryTileProps {
  category: string;
  onCategoryClick: (category: string) => void;
  small?: boolean;
  /** Gradient banner (Add Feed start page and "all topics"; with `small` the subtopic strip) instead of the square tile. */
  banner?: boolean;
}

const CategoryTile: React.FC<CategoryTileProps> = ({ category, onCategoryClick, small = false, banner = false }) => {
  const displayName = formatCategory(category);
  if (!displayName) return null;

  const handleClick = () => onCategoryClick(category);
  const style = { '--cat-color': categoryColorMap[category] || 'var(--gray-400)' } as React.CSSProperties;

  // Banner: the category color as a gradient, the name bottom left and a large faded icon top right.
  if (banner)
    return (
      <div className={`categoryBanner flowFocussable flow2d ${small ? 'small' : ''}`} style={style} tabIndex={0} onClick={handleClick} onKeyDown={get2DKeyHandler(handleClick)}>
        <span className="categoryBannerIcon"><CategoryIcon category={category} size={small ? 48 : 84} color="#fff" /></span>
        <span className="categoryBannerName">{displayName.replace(/.*\//, '')}</span>
      </div>
    );

  // The category color tints the tile and fills the icon badge; the icon itself is drawn in white.
  return (
    <div
      className={`categoryTile flowFocussable flow2d ${small ? 'small' : ''}`}
      style={style}
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={get2DKeyHandler(handleClick)}
    >
      <span className="categoryTileBadge"><CategoryIcon category={category} size={small ? 18 : 26} color="#fff" /></span>
      <span className="categoryTileName">{displayName.replace(/.*\//, '')}</span>
    </div>
  );
};

export default CategoryTile;
